import React from "react";
import { CardTitle, SubTitle } from "../CustomComponents";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { FaRectangleXmark } from "react-icons/fa6";

const ViewQuestionModalData = ({ data }) => {
  return (
    <div className="w-100 mt-3">
      <div className="flex-between">
        <CardTitle classes="fw-bold text-modal-subheading" text={"Question:"} />
        <p className="p-0 m-0 fs-7 fw-normal text-black">{data?.question}</p>
      </div>
      <div className="flex-between mt-3">
        <CardTitle classes="fw-bold text-modal-subheading" text={"Value:"} />
        <p className="p-0 m-0 fs-7 fw-normal text-black">{data?.value}</p>
      </div>
      <div className="flex-between mt-3">
        <CardTitle classes="fw-bold text-modal-subheading" text={"Required:"} />
        <p className="p-0 m-0 fs-7 fw-normal text-black">
          {data?.is_required == 1 ? (
            <IoMdCheckmarkCircle color="green" size={30} />
          ) : (
            <FaRectangleXmark color="red" size={30} />
          )}
        </p>
      </div>

      <div className="flex-between mt-3">
        <SubTitle classes="fw-bold text-modal-subheading" text={"Options"} />
      </div>
      {data?.options?.length > 0
        ? data?.options?.map((dt) => (
            <li className="p-0 m-0 fs-7 fw-normal text-black mt-3">
              {dt?.option}
            </li>
          ))
        : ""}
    </div>
  );
};

export default ViewQuestionModalData;
